// extracted by mini-css-extract-plugin
export default {"list":"TaskList_list__Q1M-x","listItem":"TaskList_listItem__XsStd"};